import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { WMICSidebarBoxes } from 'gw-portals-wizard-components-ui';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { WMICRegionUrlUtil } from 'wmic-portals-url-js';
import { ERROR_CODE, WMICRichTextUtil } from 'wmic-portals-utils-js';
import { setError, ERROR_REASONS } from '../../utils/dataLayer';
import styles from './WMICContactUs.module.scss';
import metadata from './WMICContactUs.metadata.json5';
import messages from './WMICContactUs.messages';

function WMICContactUs(props) {
    const { location, match } = props;
    const translator = useTranslator();
    const { phoneNumber, phoneNumberRaw } = appConfig;
    const quoteID = _.get(location, 'state.quoteID');

    const errorMessages = _.get(location, 'state.declineMessages');
    const residenceType = _.get(location, 'state.residenceType');

   
    const submissionData = _.get(location, 'state.submissionData');

    const currentRegion = localStorage.getItem(WMICRegionUrlUtil.CONSTANTS.REGION);

    const {
        params: { displayMode }
    } = match;

    useEffect(() => {

        
        let errorReason;
        let pageName;

       
        const detectSingleReason = (singleText) => {
            const txt = singleText.toLowerCase();

            
            const hasHomeFeature = txt.includes('home feature') || txt.includes('home safety') ||
                txt.includes('physical condition') || txt.includes('repair') || txt.includes('injury') ||
                txt.includes('brush') || txt.includes('vegetation') || txt.includes('unmaintained') ||
                txt.includes('fire hydrant') || txt.includes('hydrant') || txt.includes('fire station') ||
                txt.includes('trampoline') || txt.includes('security bar');

            const hasResidenceType = txt.includes('residence type') ||
                txt.includes('type of residence') ||
                txt.includes('residence is not insured');

            const hasNonFamilyAdults = txt.includes('non-family') ||
                txt.includes('non family') ||
                txt.includes('too many residents') ||
                txt.includes('not immediate family members');

            if (hasNonFamilyAdults && hasResidenceType && hasHomeFeature) {
                return { errorReason: ERROR_REASONS.RESIDENCE_AND_HOME_FEATURES, pageName: 'sorry ko' };
            } else if (hasNonFamilyAdults && hasResidenceType) {
                return { errorReason: ERROR_REASONS.RESIDENCE_TYPE_AND_ADULTS, pageName: 'sorry ko' };
            } else if (hasNonFamilyAdults) {
                return { errorReason: ERROR_REASONS.MORE_THAN_2_NON_FAMILY_ADULTS, pageName: 'sorry ko' };
            } else if (hasHomeFeature && (txt.includes('apartment') || txt.includes('apt') || residenceType === 'Apt')) {
                return { errorReason: ERROR_REASONS.APARTMENT_HOME_FEATURES, pageName: 'sorry ko' };
            } else if (hasHomeFeature && (txt.includes('single family') || txt.includes('single-family') || residenceType === 'SingleFamily_wmic')) {
                return { errorReason: ERROR_REASONS.SINGLE_FAMILY_HOME_FEATURES, pageName: 'sorry ko' };
            } else if (hasResidenceType) {
                return { errorReason: ERROR_REASONS.RESIDENCE_TYPE_NOT_ELIGIBLE, pageName: 'sorry ko' };
            } else if (txt.includes('dog') || txt.includes('breed')) {
                return { errorReason: ERROR_REASONS.DOG_BREED_NOT_ELIGIBLE, pageName: 'sorry qnb' };
            } else if (txt.includes('property') && (txt.includes('claims') || txt.includes('insurance') || txt.includes('loss'))) {
                return { errorReason: ERROR_REASONS.PROPERTY_CLAIMS_PAST_5_YEARS, pageName: 'sorry qnb' };
            } else if (txt.includes('woodorpelletburningstove') || txt.includes('freestandingcoal') ||
                       (txt.includes('wood') && txt.includes('stove'))) {
                return { errorReason: ERROR_REASONS.WOOD_BURNING_STOVE, pageName: 'sorry qnb' };
            } else if (txt.includes('business associate') || txt.includes('clients visit')) {
                return { errorReason: ERROR_REASONS.BUSINESS_AND_CLERICAL, pageName: 'sorry qnb' };
            } else if (txt.includes('employee') || txt.includes('nannies') || txt.includes('caregiver') || txt.includes('gardener')) {
                return { errorReason: ERROR_REASONS.REGULAR_EMPLOYEES_AT_RESIDENCE, pageName: 'sorry qnb' };
            } else if (txt.includes('business') || txt.includes('daycare') || txt.includes('occupanc')) {
                if (txt.includes('clerical')) {
                    return { errorReason: ERROR_REASONS.BUSINESS_AND_CLERICAL, pageName: 'sorry qnb' };
                } else if (txt.includes('sales') || txt.includes('messenger') ||
                           txt.includes('servicing') || txt.includes('installation')) {
                    return { errorReason: ERROR_REASONS.BUSINESS_AND_SALES, pageName: 'sorry qnb' };
                } else if (txt.includes('teacher')) {
                    return { errorReason: ERROR_REASONS.BUSINESS_AND_TEACHER, pageName: 'sorry qnb' };
                }
                return { errorReason: ERROR_REASONS.BUSINESS_AND_PERMITTED_OCCUPANCIES, pageName: 'sorry qnb' };
            } else if (txt.includes('clue') || txt.includes('c.l.u.e')) {
                return { errorReason: ERROR_REASONS.CLUE_REPORT_DOWN, pageName: 'sorry qnb' };
            } else {
                return { errorReason: ERROR_REASONS.UNDERWRITING_GUIDELINES, pageName: 'sorry qnb' };
            }
        };

        switch (displayMode) {
            case ERROR_CODE.DECLINE:
            case ERROR_CODE.UW_ISSUE: {
                let detectedReasons;
                if (Array.isArray(errorMessages) && errorMessages.length > 1) {
                    const seen = new Set();
                    detectedReasons = errorMessages
                        .map(msg => detectSingleReason(msg))
                        .filter(r => {
                            if (seen.has(r.errorReason)) return false;
                            seen.add(r.errorReason);
                            return true;
                        });
                } else {
                    const singleText = Array.isArray(errorMessages) ? errorMessages.join(' ') : (errorMessages || '');
                    detectedReasons = [detectSingleReason(singleText)];
                }

                if (detectedReasons.length > 1) {
                    errorReason = detectedReasons;
                    pageName = detectedReasons[0].pageName;
                } else {
                    errorReason = detectedReasons[0].errorReason;
                    pageName = detectedReasons[0].pageName;
                }
                break;
            }
            case ERROR_CODE.PORTAL_VALIDATION:
                
                const hasRecentClaimsOrLosses = _.get(submissionData, 'lobData.homeowners.coverables.yourHome.hasRecentClaimsOrLosses');
                const hasDwellingEmployees = _.get(submissionData, 'lobData.homeowners.coverables.yourHome.hasDwellingEmployees_wmic');
                
                
                if (hasRecentClaimsOrLosses === true) {
                   
                    errorReason = ERROR_REASONS.PROPERTY_CLAIMS_PAST_5_YEARS;
                    pageName = 'sorry qnb';
                } else if (hasDwellingEmployees === true) {
                    
                    errorReason = ERROR_REASONS.REGULAR_EMPLOYEES_AT_RESIDENCE;
                    pageName = 'sorry qnb';
                } else {
                   
                    errorReason = ERROR_REASONS.QUOTE_CANNOT_BE_EDITED;
                    pageName = 'sorry callustoproceed';
                }
                break;
            case ERROR_CODE.CLUE_REPORT:
                
                errorReason = ERROR_REASONS.CLUE_REPORT_DOWN;
                pageName = 'sorry qnb';
                break;
            case ERROR_CODE.TECHNICAL_ERROR:
                errorReason = ERROR_REASONS.TECHNICAL_ERROR;
                pageName = 'sorry technicalerror';
                break;
            case ERROR_CODE.TECHNICAL_ERROR_CREATE_QUOTE:
                errorReason = ERROR_REASONS.CREATE_QUOTE;
                pageName = 'sorry technicalerror';
                break;
            case ERROR_CODE.TECHNICAL_ERROR_RETRIEVE_QUOTE:
                errorReason = ERROR_REASONS.RETRIEVE_QUOTE;
                pageName = 'sorry technicalerror';
                break;
            case ERROR_CODE.TECHNICAL_ERROR_UPDATE_QUOTE:
                errorReason = ERROR_REASONS.UPDATE_QUOTE;
                pageName = 'sorry technicalerror';
                break;
            case ERROR_CODE.INVALID_SESSION:
            case ERROR_CODE.INVALID_SUB_SESSION:
                errorReason = ERROR_REASONS.SESSION_TIMEOUT;
                pageName = 'sorry sessionexpired';
                break;
            case ERROR_CODE.QNB_UNAVAILABLE:
                errorReason = ERROR_REASONS.SYSTEM_OUTAGE;
                pageName = 'sorry maintenance';
                errorReason = ERROR_REASONS.SYSTEM_OUTAGE;
                pageName = 'sorry maintenance';
                break;
            default:
                errorReason = ERROR_REASONS.TECHNICAL_ERROR;
                pageName = 'sorry technicalerror';
        }

        console.log('[WMICContactUs] Error mapped:', {
            displayMode,
            errorReason,
            pageName
        });

       
        if (errorReason) {
            if (Array.isArray(errorReason)) {
                setError(errorReason);
            } else {
                setError(errorReason, pageName);
            }
            
            
            const fullErrorPage = `insurance:renters:quote:${pageName}`;
            if (window.wins_data_layer) {
                window.wins_data_layer.page = fullErrorPage;
            }
            
            
            if (window.utag && window.utag.view) {
                const state = localStorage.getItem('selectedState') || 'CA';
                window.utag.view({
                    ...(window.wins_data_layer || {}),
                    ins_quoteid: quoteID,
                    state: state.toUpperCase()
                });
                console.log('[WMICContactUs] Analytics tracked:', { errorReason, pageName, quoteID });
            } else {
                console.warn('[WMICContactUs] Adobe Analytics not available');
            }
        } else {
            console.error('[WMICContactUs] No error reason mapped for displayMode:', displayMode);
        }
    }, [displayMode, quoteID, errorMessages]);

    let callSpecialistsMessage;
    let fairPlan;

    switch (currentRegion) {
        case WMICRegionUrlUtil.CONSTANTS.CA_SHORT:
            callSpecialistsMessage = WMICRichTextUtil.translateRichText(translator(messages.callWithNumCA, {phoneNumberRaw, phoneNumber}));
            fairPlan = WMICRichTextUtil.translateRichText(translator(messages.calFP));
            break;
        case WMICRegionUrlUtil.CONSTANTS.OR_SHORT:
        default:
            callSpecialistsMessage = WMICRichTextUtil.translateRichText(translator(messages.callWithNumOR, {phoneNumberRaw, phoneNumber}));
            fairPlan = WMICRichTextUtil.translateRichText(translator(messages.orFP));
    }

    const getAssistanceText = useCallback(() => {
        return (
            <FormattedMessage
                {...messages.furtherAssist}
                values={{
                    link: <Link to='/retrieve-quote'>{translator(messages.furtherAssistLink)}</Link>,
                    phoneNumber
                }}
            />
        );
    }, [phoneNumber, translator]);

    const overrideProps = {
        decline: {
            visible: displayMode === ERROR_CODE.DECLINE
        },
        contactMain: {
            visible: displayMode === ERROR_CODE.UW_ISSUE
                || displayMode === ERROR_CODE.CLUE_REPORT
                || displayMode === ERROR_CODE.PORTAL_VALIDATION
        },
        contact2: {
            content: translator(messages.specialSolution, { phoneNumber })
        },
        techErrorMain: {
            visible: displayMode === ERROR_CODE.TECHNICAL_ERROR
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_UPDATE_QUOTE
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_RETRIEVE_QUOTE
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_CREATE_QUOTE
        },
        technicalError: {
            visible: displayMode === ERROR_CODE.TECHNICAL_ERROR
                || displayMode === ERROR_CODE.TECHNICAL_ERROR_RETRIEVE_QUOTE
                || displayMode === ERROR_CODE.TECHNICAL_ERROR_CREATE_QUOTE
                || displayMode === ERROR_CODE.TECHNICAL_ERROR_UPDATE_QUOTE
        },
        invalidSession: {
            visible: displayMode === ERROR_CODE.INVALID_SESSION
        },
        techErrorMessage1: {
            visible: displayMode === ERROR_CODE.TECHNICAL_ERROR
        },
        techErrorMessage2: {
            visible: displayMode === ERROR_CODE.TECHNICAL_ERROR_RETRIEVE_QUOTE
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_CREATE_QUOTE
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_UPDATE_QUOTE
        },
        techError: {
            visible: displayMode === ERROR_CODE.TECHNICAL_ERROR
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_UPDATE_QUOTE
            || displayMode === ERROR_CODE.TECHNICAL_ERROR_RETRIEVE_QUOTE,
            content: translator(messages.callTechError, { phoneNumber })
        },
        techErrorCreate: {
            visible: displayMode === ERROR_CODE.TECHNICAL_ERROR_CREATE_QUOTE,
            content: translator(messages.callTechErrorCreate, { phoneNumber })
        },
        quoteSaved: {
            visible: !_.isNil(quoteID),
            content: translator(messages.quoteSaved, { quoteId: quoteID })
        },
        declineQuoteId: {
            visible: !_.isNil(quoteID),
            content: translator(messages.quoteIs, { quoteId: quoteID })
        },
        contactQuoteId: {
            visible: !_.isNil(quoteID),
            content: translator(messages.quoteIs, { quoteId: quoteID })
        },
        unavailable: {
            visible: displayMode === ERROR_CODE.QNB_UNAVAILABLE
        },
        callAgent: {
            content: WMICRichTextUtil.translateRichText(translator(messages.callAgent))
        },
        callSpecialists: {
            content: callSpecialistsMessage
        },
        declineMessage: {
            visible: !_.isEmpty(errorMessages),
            content: errorMessages
        },
        fairPlan: {
            content: fairPlan
        },
        callOrRetrieveQuote: {
            content: getAssistanceText()
        },
        returnToWInsurance: {
            visible: displayMode !== ERROR_CODE.QNB_UNAVAILABLE
        }
    };

    const resolvers = {
        resolveComponentMap: {
            wmicSidebarBoxes: WMICSidebarBoxes,
        },
        resolveClassNameMap: styles
    };

    return (
        <div>
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                {...resolvers} />
        </div>
    );
}

WMICContactUs.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            error: PropTypes.shape({
                gwInfo: PropTypes.shape({})
            })
        })
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            displayMode: PropTypes.string
        })
    })
};
WMICContactUs.defaultProps = {
    location: undefined,
    match: {
        params: {
            displayMode: 'invalid'
        }
    }
};
export default withRouter(WMICContactUs);
